import { useParams } from "react-router-dom";
import { SurveyForm } from "@/components/admin/survey/SurveyForm";
import { useGroupLeaderSurvey } from "@/hooks/useGroupLeaderSurvey";

const GroupLeaderSurvey = () => {
  const { meetingNumber } = useParams();
  const { formData, isSubmitting, isLoading, handleInputChange, handleSubmit } = useGroupLeaderSurvey(meetingNumber || "1");

  if (isLoading) {
    return (
      <div className="container max-w-2xl py-8">
        <div className="text-center">Laddar...</div>
      </div>
    );
  }

  return (
    <div className="container max-w-2xl py-8">
      <SurveyForm
        formData={formData}
        isSubmitting={isSubmitting}
        onInputChange={handleInputChange}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default GroupLeaderSurvey;